import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GameContext } from "../../Context/GameContext";
import { resetDorkyTerminalState } from "../Rooms/Room8/Clues/ClueObjectDorkyAI";

type Props = { className?: string };

const ControlButtons: React.FC<Props> = ({ className = "" }) => {
  const navigate = useNavigate();
  const { resetRoomProgress } = useContext(GameContext);

  const handleReset = (e: React.MouseEvent) => {
    e.preventDefault();            // stop the default link nav
    resetRoomProgress();           // clear progress
    resetDorkyTerminalState();     // reset Dorky Room8
    navigate("/");                 // then go home
  };

  return (
    <div className={`control-buttons ${className}`} role="region" aria-label="Admin controls">
        <Link
        to="/leaderboard"
        className="leaderboard"
        title="Open leaderboard"
        aria-label="Open leaderboard in a new tab"
        target="_blank"
        rel="noopener noreferrer"
      />
      <Link to="/settings" className="settings" title="Admin" aria-label="Open admin" />
      <Link
        to="/"
        className="refresh"
        title="Reset session"
        aria-label="Reset session"
        onClick={handleReset}
      />
    </div>
  );
};

export default ControlButtons;
